import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import PaymentLink from '../../../molecules/PaymentLink/PaymentLink';
import {VrbexConsumer} from '../../../context/VrbexContext';

import './MessageAction.less';

export class MessageAction extends React.Component {
    static propTypes = {
        actionTitle: PropTypes.string,
        actionUrl: PropTypes.string,
        backUrl: PropTypes.string,
        ctaDetails: PropTypes.shape({}),
        conversationId: PropTypes.string,
        isHybridInbox: PropTypes.bool,
    };

    static defaultProps = {
        backUrl: '/traveler/th/inbox',
    };

    render() {
        const commonClass = 'btn--nowrap btn--clear-top';
        const {
            actionTitle,
            actionUrl,
            backUrl,
            ctaDetails: {tripPaymentsLink},
            conversationId,
            isHybridInbox,
        } = this.props;

        return (
            <VrbexConsumer>
                {({isVrbexNative}) => (
                    <div className="message__action">
                        {actionUrl && (
                            <Button
                                block
                                className={commonClass}
                                href={actionUrl}
                                label={actionTitle}
                            />
                        )}

                        {!actionUrl && isHybridInbox && (
                            <PaymentLink
                                backUrl={backUrl}
                                conversationId={conversationId}
                                isVrbexNative={isVrbexNative}
                                tripPaymentsLink={tripPaymentsLink}
                            >
                                <ButtonPrimary
                                    block
                                    className={commonClass}
                                    label={actionTitle}
                                />
                            </PaymentLink>
                        )}

                        {!actionUrl && !isHybridInbox && (
                            <Link
                                to={{
                                    pathname: `/traveler/th/inbox/conversation/${conversationId}/payments`,
                                    state: {
                                        backUrl,
                                        tabChange: true,
                                    },
                                }}
                                data-testid="action_url_link"
                            >
                                <ButtonPrimary
                                    block
                                    className={commonClass}
                                    label={actionTitle}
                                />
                            </Link>
                        )}
                    </div>
                )}
            </VrbexConsumer>
        );
    }
}
